<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Gaho
 * @LastEditTime: 2024-08-06 17:51:53
 * @FilePath: /gamefi/components/Casino/GameSettings/Button/LiveChat/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>                            
    <GameSettingsButtonWrapper
        :tool-tip="t.Statistics"
        :enable="modelValue"
        @click.self="onClick()"
        class="relative live-chat-icon"
    >
        <IconSvgUse
            use="icon-statistic"
            @click.native="onClick()"
            name="chat_bubble_outline"
            class="w-[14px] h-[14px]"
        />
    </GameSettingsButtonWrapper>
    <GameSettingsButtonLiveChatMobile 
        v-if="modelValue"
        :isShow="modelValue"
        @update:modelValue="onClick"
        :liveChatIconWidth="liveChatIconWidth"
    />
</template>

<script setup lang="ts">
// stores
// functions
import useTranslation from '~/i18n/useTransLation';
import betHelper from '@/common/js/betHelper';

const isCollapsed = ref(false);
const liveChatIconWidth = ref(0); // livechat按钮宽度

const t = useTranslation();
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['update:modelValue']);
onMounted(() => {
    isCollapsed.value = false;
    
    window.addEventListener('resize', handleResize);
})
const onClick = async () => {
    if (!betHelper.checkIslogin()){
        return;
    }
    emit('update:modelValue', !props.modelValue);
};
/**
 * 视图size发生变化
 */
const handleResize = async () => {
    if (!props.modelValue) return;
    await nextTick();
    const liveChatIcon = document.querySelector('.live-chat-icon');
    liveChatIconWidth.value = liveChatIcon && liveChatIcon.clientWidth;
}
watch(() => props.modelValue, async (newVal, oldVal) => {
    // 打开弹框时 绑定livechat事件
    if (newVal && newVal !== oldVal){
        handleResize();
    }
}, {
    deep: true,
    immediate: true
})
onBeforeUnmount(() => {
    if (props.modelValue){
        window.removeEventListener('resize', handleResize);
    }
})
</script>

<style scoped lang="scss">
#liveChat {
    top: 0;
    left: 0;
    @media (max-width: 576px) {
        top: 63px;
    }
}

.header::before {
    background: linear-gradient(180deg, #003370, transparent);
    border-radius: 14px 14px 0 0;
    content: '';
    display: block;
    height: 72px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
}
.live-title {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
    margin: 0 0 0 10px;
    user-select: none;
    @media (max-width: 1000px) {
        font-size: 18px;
    }
}
.live-refresh {
    margin: 0 9px;
    padding: 0;
    background-image: none;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    font-size: 24px;
    height: 24px;
    width: 24px;

    svg {
        fill: #2283f6;
        transition: fill .1s ease-in-out;
    }
}
.close-icon {
    align-items: center;
    background-color: transparent;
    border: none;
    color: #93acd3;
    display: flex;
    font-size: 38px;
    font-weight: 500;
    height: 38px;
    justify-content: center;
    line-height: 38px;
    outline: none;
    padding: 0;
    position: absolute;
    right: 15px;
    top: 15px;
    transition: color .1s ease-in-out;
    width: 38px;
    z-index: 10;
}
.collpase {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='16' fill='none'%3E%3Cpath fill='%235596E4' fill-opacity='.4' d='M7 11c1 3 3 5 6 5h24c3 0 5-2 6-4l2-8c0-1 2-4 5-4H0c3 0 5 3 5 4z'/%3E%3C/svg%3E");
    border: none;
    height: 16px;
    line-height: 1;
    padding: 0;
    transform: translate(-50%);
    width: 50px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
}

.stats-charts {
    height: 178px;
    padding: 16px;
    background: #141820;
    border-radius: 8px;
    margin-bottom: 12px;
    width: 268px;
    @media(max-width: 1000px){
        margin-bottom: 8px;
    }
}

</style>
